export default [
  {
    path: '/integrations/billers/built_in/purchases',
    name: 'PurchaseList',
    component: () => import(/* webpackChunkName: "purchases" */ '@/views/purchases/PurchaseList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Compras'
    }
  },
  {
    path: '/integrations/billers/built_in/purchases/:id',
    name: 'PurchaseRetrieve',
    component: () => import(/* webpackChunkName: "purchases" */ '@/views/purchases/PurchaseRetrieve.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Compra'
    }
  },
  {
    path: '/integrations/billers/built_in/retentions',
    name: 'RetentionList',
    component: () => import(/* webpackChunkName: "purchases" */ '@/views/integrations/billers/built_in/RetentionList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Retenciones'
    }
  },
  {
    path: '/integrations/billers/built_in/retentions/:id',
    name: 'RetentionRetrieve',
    component: () => import(/* webpackChunkName: "purchases" */ '@/views/integrations/billers/built_in/RetentionRetrieve.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Compra'
    }
  },
  {
    path: '/integrations/billers/built_in/retentions/:id/edit',
    name: 'RetentionUpdate',
    component: () => import(/* webpackChunkName: "purchases" */ '@/views/integrations/billers/built_in/RetentionCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Editar retención'
    }
  },
  {
    path: '/integrations/billers/built_in/retentions/create',
    name: 'RetentionCreate',
    component: () => import(/* webpackChunkName: "purchases" */ '@/views/integrations/billers/built_in/RetentionCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Crear retención'
    }
  },
  {
    path: '/integrations/billers/built_in/bulks/retentions',
    name: 'RetentionBulkListCreate',
    component: () => import(/* webpackChunkName: "purchases" */ '@/views/integrations/billers/built_in/RetentionBulkListCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Retenciones'
    }
  },
  {
    path: '/integrations/billers/built_in/bulks/retentions/:id',
    name: 'RetentionBulkRetrieve',
    component: () => import(/* webpackChunkName: "purchases" */ '@/views/integrations/billers/built_in/RetentionBulkRetrieve.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Retenciones'
    }
  }
]